import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Flex, Heading, Box } from 'roo-ui/components';
import RatingFilterElement from 'components/Filters/Search/RatingFilter/RatingFilterElement/RatingFilterElement';
import FilterContainer from 'components/Filters/FilterContainer';
import TextButton from 'components/TextButton';
import { getQueryMinTripadvisorRating } from 'store/search/searchSelectors/querySelectors';

const RATING_TYPE = 'minTripadvisorRating';

const TripadvisorRatingFilter = ({ onChange, displayClearFilter, onClearFilter }) => {
  const minTripadvisorRating = useSelector(getQueryMinTripadvisorRating);

  return (
    <Fragment>
      <Flex justifyContent="space-between">
        <Flex alignItems="center">
          <Heading.h2 fontSize="sm">Tripadvisor Rating</Heading.h2>
        </Flex>
        {displayClearFilter && (
          <Box>
            <TextButton data-testid="clear-tripadvisor-button" fontSize="sm" color="brand.primary" onClick={onClearFilter}>
              Clear
            </TextButton>
          </Box>
        )}
      </Flex>
      <Box mb={[0, displayClearFilter ? 0 : 6]}>
        <FilterContainer data-testid="tripadvisor-rating-filter">
          <RatingFilterElement
            text="Excellent 5.0"
            rating="5"
            currentRating={minTripadvisorRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="Very good 4.0 & up"
            rating="4"
            currentRating={minTripadvisorRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="Average 3.0 & up"
            rating="3"
            currentRating={minTripadvisorRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
          <RatingFilterElement
            text="All ratings"
            currentRating={minTripadvisorRating}
            onChange={onChange}
            ratingType={RATING_TYPE}
            showRatingStars={false}
          />
        </FilterContainer>
      </Box>
    </Fragment>
  );
};

TripadvisorRatingFilter.propTypes = {
  minTripadvisorRating: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

TripadvisorRatingFilter.defaultProps = {
  minTripadvisorRating: undefined,
  displayClearFilter: false,
  onClearFilter: () => {},
};

export default TripadvisorRatingFilter;
